import { useCookies } from 'react-cookie';
import useAuthStore from 'store/auth';

const COOKIE_NAME = 'first-approved-visit';

export default function useFirstApprovedVisit() {
  const profileId = useAuthStore((store) => store.currentUserProfileId);

  const [cookies, setCookie] = useCookies();

  const updateApprovedVisit = () => {
    const updatedIds = !cookies[COOKIE_NAME]
      ? JSON.stringify([profileId])
      : JSON.stringify([...cookies[COOKIE_NAME], profileId]);
    setCookie(COOKIE_NAME, updatedIds);
  };

  const hasVisited =
    Boolean(cookies[COOKIE_NAME] && cookies[COOKIE_NAME].includes(profileId)) ||
    false;

  return { updateApprovedVisit, hasVisited };
}
